
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// تحديد إعادة تفريغ الكاش للأنماط
const meta = document.createElement('meta');
meta.httpEquiv = 'Cache-Control';
meta.content = 'no-cache, no-store, must-revalidate';
document.head.appendChild(meta);

// تحديد دالة التحميل الرئيسية
const renderApp = () => {
  const rootElement = document.getElementById("root");
  if (rootElement) {
    const root = createRoot(rootElement);
    root.render(<App />);
  }
};

// تشغيل التطبيق
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', renderApp);
} else {
  renderApp();
}
